export default __webpack_public_path__ + "static/media/unselected9.3913307a.png";